<div class="comments-page">

  <div class="container comments-shell">

    <!-- =====================================================
         ERREUR
         ===================================================== -->

    <div
      class="alert alert-danger comments-alert"
      *ngIf="messageError">

      {{ messageError }}

    </div>


    <!-- =====================================================
         HEADER ELEVE
         ===================================================== -->

    <section
      class="comments-hero"
      *ngIf="student">

      <div class="comments-student">

        <div class="student-avatar">
          {{ studentInitials }}
        </div>

        <div class="comments-identity">

          <div class="comments-badges">

            <span class="comments-chip">
              Dossier élève
            </span>

            <span class="comments-chip comments-chip--blue">
              Remarques de conduite
            </span>

          </div>

          <h1>
            {{ student.lastname }}
            {{ student.firstname }}
          </h1>

          <p>
            Suivi des remarques et observations
            enregistrées après les leçons de conduite.
          </p>

        </div>

      </div>


      <div
        class="comments-action"
        *ngIf="isMonitor">

        <button
          type="button"
          class="btn btn-primary comments-add-button"
          (click)="addComment()">

          <i class="fa fa-plus"></i>

          Ajouter une remarque

        </button>

      </div>

    </section>


    <!-- =====================================================
         RESUME
         ===================================================== -->

    <section class="comments-summary">

      <article class="summary-card">

        <div class="summary-icon summary-icon--blue">

          <i class="fa fa-comments"></i>

        </div>

        <div>

          <span class="summary-label">
            Remarques
          </span>

          <strong>
            {{ totalSessions }}
          </strong>

          <small>
            commentaire{{ totalSessions > 1 ? 's' : '' }}
            enregistré{{ totalSessions > 1 ? 's' : '' }}
          </small>

        </div>

      </article>


      <article class="summary-card">

        <div class="summary-icon summary-icon--green">

          <i class="fa fa-calendar"></i>

        </div>

        <div>

          <span class="summary-label">
            Dernière remarque
          </span>

          <strong
            class="summary-date"
            *ngIf="lastCommentDate">

            {{ lastCommentDate | date:'dd/MM/yyyy' }}

          </strong>

          <strong
            class="summary-date"
            *ngIf="!lastCommentDate">

            -

          </strong>

          <small>
            Dernière observation enregistrée
          </small>

        </div>

      </article>

    </section>


    <!-- =====================================================
         HISTORIQUE
         ===================================================== -->

    <section class="comments-panel">

      <div class="comments-panel-head">

        <div>

          <span class="comments-panel-label">
            Historique
          </span>

          <h2>
            Leçons et commentaires
          </h2>

          <p>
            Retrouvez les remarques de conduite
            de la plus récente à la plus ancienne.
          </p>

        </div>


        <span class="comments-count">

          {{ totalSessions }}
          remarque{{ totalSessions > 1 ? 's' : '' }}

        </span>

      </div>


      <!-- =================================================
           VIDE
           ================================================= -->

      <div
        *ngIf="
          !drivingComments ||
          !sortedDrivingCommentsDesc.length
        "
        class="comments-empty">

        <div class="comments-empty-icon">

          <i class="fa fa-commenting-o"></i>

        </div>

        <h3>
          Aucune remarque pour le moment
        </h3>

        <p>
          Les commentaires de conduite
          apparaîtront ici après une leçon.
        </p>


        <button
          *ngIf="isMonitor"
          type="button"
          class="btn btn-primary"
          (click)="addComment()">

          <i class="fa fa-plus"></i>

          Ajouter la première remarque

        </button>

      </div>


      <!-- =================================================
           TIMELINE
           ================================================= -->

      <div
        class="comments-list"
        *ngIf="sortedDrivingCommentsDesc.length">


        <article
          class="comments-entry"
          *ngFor="
            let d of sortedDrivingCommentsDesc;
            let i = index
          ">


          <!-- NUMERO -->

          <div class="comments-entry-number">

            {{ totalSessions - i }}

          </div>


          <!-- CONTENU -->

          <div class="comments-entry-card">

            <div class="comments-entry-header">

              <div>
                <h3 class="comments-entry-title">

                  Leçon n°{{ totalSessions - i }}

                </h3>

              </div>


              <div class="comments-entry-tools">

                <span class="comments-date">

                  <i class="fa fa-calendar-o"></i>

                  {{ d.date | date:'dd/MM/yyyy à HH:mm' }}

                </span>


                <button
                  type="button"
                  class="comments-entry-edit"
                  aria-label="Modifier la remarque"
                  (click)="
                    editComment(
                      d.id,
                      d.date,
                      d.comment
                    )
                  "
                  *ngIf="d.userId == userId">

                  <i class="fa fa-pencil"></i>

                </button>

              </div>

            </div>


            <div class="comments-entry-body">

              <i
                class="fa fa-quote-left comments-quote-icon">
              </i>

              <p
                class="comments-entry-content"
                id="c-{{ d.id }}">

                {{ d.comment }}

              </p>

            </div>

          </div>

        </article>

      </div>

    </section>

  </div>


  <!-- =====================================================
       MODAL
       ===================================================== -->

  <div
    class="modal fade comments-modal"
    id="drivingCommentModal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true">

    <div
      class="modal-dialog modal-lg modal-dialog-centered"
      role="document">

      <div class="modal-content comments-modal-card">


        <!-- HEADER -->

        <div class="modal-header comments-modal-header">

          <div>

            <span class="modal-chip">

              {{
                commentForm.value.id
                  ? 'Modification'
                  : 'Nouvelle remarque'
              }}

            </span>


            <h3
              class="modal-title"
              *ngIf="student">

              {{
                commentForm.value.id
                  ? 'Modifier la remarque'
                  : 'Ajouter une remarque'
              }}

            </h3>


            <p *ngIf="student">

              {{ student.lastname }}
              {{ student.firstname }}

            </p>

          </div>


          <button
            type="button"
            class="close comments-modal-close"
            data-dismiss="modal"
            aria-label="Fermer">

            <span aria-hidden="true">
              &times;
            </span>

          </button>

        </div>


        <!-- FORM -->

        <form
          [formGroup]="commentForm"
          #f2="ngForm"
          (ngSubmit)="validComment()"
          novalidate>


          <div class="modal-body comments-modal-body">


            <!-- DATE -->

            <div class="comments-field">

              <label for="commentDate">

                Date de la leçon

              </label>


              <div class="comments-input-wrapper">

                <i class="fa fa-calendar"></i>

                <input
                  id="commentDate"
                  type="date"
                  class="form-control"
                  formControlName="date"
                  readonly>

              </div>

            </div>


            <!-- COMMENT -->

            <div class="comments-field">

              <label for="commentBody">

                Commentaire

              </label>

              <textarea
                id="commentBody"
                class="form-control comments-textarea"
                formControlName="comment"
                rows="7"
                placeholder="Saisissez les remarques concernant la conduite de l'élève...">
              </textarea>


              <p
                class="comments-error"
                *ngIf="
                  f2.submitted &&
                  commentForm.get('comment')?.invalid
                ">

                Merci de renseigner un commentaire.

              </p>

            </div>

          </div>


          <!-- FOOTER -->

          <div class="modal-footer comments-modal-footer">

            <button
              type="button"
              class="btn comments-cancel-button"
              data-dismiss="modal">

              Annuler

            </button>


            <button
              type="submit"
              class="btn btn-primary comments-save-button">

              <i class="fa fa-check"></i>

              {{
                commentForm.value.id
                  ? 'Enregistrer les modifications'
                  : 'Ajouter la remarque'
              }}

            </button>

          </div>

        </form>

      </div>

    </div>

  </div>

</div>
